/* ------------------------------------------------------------------------ */
/*		File: cmpPreviewPlan.tsx                                            */
/*		Description: Component Implementation                               */
/*		Project: iSymWebSchool											    */
/*		Author: ISym Global Solutions Limited                               */
/*		Version: 1.0													    */
/* ------------------------------------------------------------------------ */


import React from "react";
import { ICmpPreviewPlan } from "./cmpPreviewPlan.d";
import Button from "../GenericComponents/Button";
import { getImage } from "../../components/GenericComponents/functions";
import "./cmpPreviewPlan.css";

/* ------------------------------------------------------------------------ */

const PreviewPlan: React.FC<ICmpPreviewPlan> = (props) => {
    props.options?.sort((a, b) => { return (a.position! < b.position! ?  -1 : 0)})

    return (
        <div className="card_previewplan">
            <div className="card_previewplan_label">{props.label}</div>
            {props.options!.map((item, index) => (
                <div className="card_previewplan_option">
                    <div className="card_previewplan_option bullet">
                        <img src={getImage("check.svg")} alt={"check.svg"}/>
                    </div>
                    <div className="card_previewplan_option text">{item.label}</div>
                </div>
            )) }

            <div className="card_previewplan_button">
                <Button 
                    classProp={"yellow-button"}
                    label={props.textButton}
                    hasIcon={false}
                    size={"medium"}
                    //textColor={colorType.BLUE}
                    onClick={props.onClick}
                />   
            </div>
        </div>
    );
};

export default PreviewPlan; 